import { ServiceBase } from '../../../../core/services/ServiceBase'
import CategoryProxy from './proxy'

const slidingExpireTimeInMinute = 60 * 24 // 1 day

class CategoryService extends ServiceBase {
  getLocation(params) {
    return this.applyMemoryCache(
      'CategoryService.getLocation',
      params,
      undefined,
      slidingExpireTimeInMinute,
    )(() => CategoryProxy.getLocation(params))
  }

  getVietnameseLocation(params) {
    return this.applyMemoryCache(
      'CategoryService.getVietnameseLocation',
      params,
      undefined,
      slidingExpireTimeInMinute,
    )(() => CategoryProxy.getVietnameseLocation(params))
  }

  getVsic(params) {
    return this.applyMemoryCache(
      'CategoryService.getVsic',
      params,
      undefined,
      slidingExpireTimeInMinute,
    )(() => CategoryProxy.getVsic(params))
  }

  getIcb(params) {
    return this.applyMemoryCache(
      'CategoryService.getIcb',
      params,
      undefined,
      slidingExpireTimeInMinute,
    )(() => CategoryProxy.getIcb(params))
  }

  getTimezone(params) {
    return this.applyMemoryCache(
      'CategoryService.getTimezone',
      params,
      undefined,
      slidingExpireTimeInMinute,
    )(() => CategoryProxy.getTimezone(params))
  }

  getLegalRegulations(params) {
    return this.applyMemoryCache(
      'CategoryService.getLegalRegulations',
      params,
      undefined,
      slidingExpireTimeInMinute,
    )(() => CategoryProxy.getLegalRegulations(params))
  }

  getPricingPackages(params) {
    return this.getData(() => CategoryProxy.getPricingPackages(params))
  }

  getPricingPackagesByUserType(params) {
    return this.getData(() =>
      CategoryProxy.getPricingPackagesByUserType(params),
    )
  }

  getExchangeRates(params) {
    return this.getData(() => CategoryProxy.getExchangeRates(params))
  }

  getVAT(params) {
    return this.getData(() => CategoryProxy.getVAT(params))
  }

  getCompanyHeader(params) {
    return this.getData(() => CategoryProxy.getCompanyHeader(params))
  }

  getUserProfile(params) {
    return this.getData(() => CategoryProxy.getUserProfile(params))
  }

  getVietnameseProvinces(params) {
    return this.applyMemoryCache(
      'CategoryService.getVietnameseProvinces',
      params,
      undefined,
      slidingExpireTimeInMinute,
    )(() => CategoryProxy.getVietnameseProvinces(params))
  }

  getForeignRegions(params) {
    return this.applyMemoryCache(
      'CategoryService.getForeignRegions',
      params,
      undefined,
      slidingExpireTimeInMinute,
    )(() => CategoryProxy.getForeignRegions(params))
  }

  getJobTitles(params) {
    return this.applyMemoryCache(
      'CategoryService.getJobTitles',
      params,
      undefined,
      slidingExpireTimeInMinute,
    )(() => CategoryProxy.getJobTitles(params))
  }

  getCountries(params) {
    return this.applyMemoryCache(
      'CategoryService.getCountries',
      params,
      undefined,
      slidingExpireTimeInMinute,
    )(() => CategoryProxy.getCountries(params))
  }

  getDiscountOrder(params) {
    return this.getData(() => CategoryProxy.getDiscountOrder(params))
  }

  putLanguage(params) {
    return this.getData(() => CategoryProxy.putLanguage(params), true)
  }
}

export default new CategoryService()
